/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import axios from "axios";
import { Auth } from "aws-amplify";
import { v2, errorToObject } from "@prftesp/cle-logger";
import errorCodes from "../../../utility/errorCodes";
import { APIGateways } from "../../../utility/APIGateways";

const COMPONENT_NAME = "adminCCPServices/teamsService";

/**
 * This method makes an api call to a lambda via an api gateway secured by cognito pool to
 * get Teams user status by azure user id
 * @param {[string]} azureUserIds List of Azure user ids
 */
export const getTeamsUserStatuses = async (azureUserIds) => {
	try {
		const token = (await Auth.currentSession()).getIdToken().getJwtToken();
		const response = await axios.post(`${APIGateways.teamsEndpoint}/user-statuses`, azureUserIds, {
			headers: {
				Authorization: token,
			},
		});
		return response.data;
	} catch (error) {
		v2.error("Error while getting teams user statuses", {
			additionalData: { error: errorToObject(error), data: { azureUserIds } },
			componentName: COMPONENT_NAME,
			logCode: errorCodes.GET_TEAMS_USER_STATUSES_API_ERROR,
		});

		return {};
	}
};

/**
 * This method makes an api call to a lambda via an api gateway secured by cognito pool to
 * get Update the Teams user status by azure user id
 * @param {[string]} userAzureId List of Azure user ids
 */
export const updateTeamsUserStatus = async (actionType, userAzureId) => {
	try {
		const token = (await Auth.currentSession()).getIdToken().getJwtToken();
		const response = await axios.post(
			`${APIGateways.teamsEndpoint}/set-user-status`,
			{ action: actionType, userAzureId },
			{
				headers: {
					Authorization: token,
				},
			},
		);
		return response.data;
	} catch (error) {
		v2.error("Error while updating teams user statuses", {
			additionalData: { error: errorToObject(error), data: { userAzureId } },
			componentName: COMPONENT_NAME,
			logCode: errorCodes.SET_TEAMS_PRESENCE_ERROR,
		});

		return {};
	}
};
